export default __webpack_public_path__ + "591eaf8eea62f0a8ef232bcc0a18a899.svg";